/* 20240628 ブログ掲載画面仕様変更 START */

// 目次生成
document.addEventListener('DOMContentLoaded', function () {
    const article = document.querySelector('.article-template');
    const headingArray = article.querySelectorAll('h2');

    // H2タグがなければ目次アコーディオンを追加しない
    if (headingArray.length === 0) return;

    // 目次部分の作成
    const articleContent = document.querySelector('.article-template__content');
    articleContent.insertAdjacentHTML('afterbegin', `
        <div class="tableContent-wrapper">
            <button class="tableContent-title active">目次</button>
            <div id="tableContent" class="tableContent active"></div>
        </div>
    `);

    const blogIndex = article.querySelector('#tableContent');
    const titleButton = article.querySelector('.tableContent-title');

    // 高さを自動からスクロール高さに設定して、トランジションが機能するようにする
    setTimeout(() => {
        if (blogIndex.classList.contains('active')) {
            blogIndex.style.height = blogIndex.scrollHeight + 'px';
        }
    }, 10);

    // 目次アコーディオンの設定
    titleButton.addEventListener('click', function () {
        if (blogIndex.classList.contains('active')) {
            blogIndex.style.height = '0';
            blogIndex.classList.remove('active');
            titleButton.classList.remove('active');
        } else {
            const height = blogIndex.scrollHeight + 'px';
            blogIndex.style.height = height;
            blogIndex.classList.add('active');
            titleButton.classList.add('active');
        }
    });

    // 目次内容の生成
    let h2Number = 1;
    headingArray.forEach((heading) => {
        heading.id = 'id2-' + h2Number;
        let p = document.createElement('p');
        let a = document.createElement('a');
        p.insertAdjacentHTML('afterbegin', `<span class="indexNumber">${h2Number}. </span>`);
        a.textContent = heading.textContent;
        a.href = '#' + 'id2-' + h2Number;
        p.className = 'tableContent-h2';
        p.style.display = "block";
        p.append(a);
        blogIndex.append(p);
        h2Number++;
    });

    // ページ内リンク
    const links = document.querySelectorAll('.tableContent-h2 a');
    links.forEach((link) => {
        link.addEventListener('click', (event) => {
            event.preventDefault();  // リンクのデフォルト動作をキャンセル
            smoothScroll(link.hash);
        });
    });
});

// スムーススクロール
function smoothScroll(target) {
    const element = document.querySelector(target);
    const headerHeight = document.querySelector('.hdr--typeD').offsetHeight; // ヘッダーの高さを取得
    const offset = 10;  // 上端からの追加オフセット
    const elementPosition = element.offsetTop - headerHeight - offset; // ヘッダーの高さと追加オフセットを差し引く
    // スクロール位置を計算して設定
    window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
    });
}
/* 20240628 ブログ掲載画面仕様変更 END */

/* 20240724 商品詳細ページ - 仕様変更対応 START */
document.querySelectorAll('.tooltip').forEach(item => {
    item.addEventListener('click', function () {
        const tooltipText = this.querySelector('.tooltiptext');
        if (tooltipText.style.visibility === 'visible') {
            tooltipText.style.visibility = 'hidden';
            tooltipText.style.opacity = '0';
        } else {
            tooltipText.style.visibility = 'visible';
            tooltipText.style.opacity = '1';
        }
    });
});
/* 20240724 商品詳細ページ - 仕様変更対応 END */



/* 20250412 4月仕様変更対応 START */
// 続きを読む
document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 768) {
        const target = document.querySelector('.author-info .metafield-multi_line_text_field');
        if (target) {
            // クラスを追加
            target.classList.add('js-readmore');

            // ボタンを作成
            const button = document.createElement('button');
            button.textContent = '…続きを読む';
            button.className = 'readmore-button';

            // ボタンを挿入（spanの直後に）
            target.parentNode.appendChild(button);

            // ボタンクリックイベント
            button.addEventListener('click', function () {
                target.style.display = 'block';
                target.style.webkitLineClamp = 'unset';
                target.style.overflow = 'visible';
                target.style.display = 'block';
                button.style.display = 'none';
            });
        }
    }
});

document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 768) {
        const target = document.querySelector('.profile-card .metafield-multi_line_text_field');
        if (target) {
            // クラスを追加
            target.classList.add('js-readmore');

            // ボタンを作成
            const button = document.createElement('button');
            button.textContent = '…続きを読む';
            button.className = 'readmore-button';

            // ボタンを挿入（spanの直後に）
            target.parentNode.appendChild(button);

            // ボタンクリックイベント
            button.addEventListener('click', function () {
                target.style.display = 'block';
                target.style.webkitLineClamp = 'unset';
                target.style.overflow = 'visible';
                target.style.display = 'block';
                button.style.display = 'none';
            });
        }
    }
});
/* 20250412 4月仕様変更対応 END */